import type { Dict } from './en'

export const ru: Dict = {
  lang: { en: 'English', uk: 'Українська', ru: 'Русский', label: 'Язык' },

  nav: {
    overview: 'Обзор',
    posting: 'Постинг',
    settings: 'Настройки',
    dashboard: 'Дашборд',
    phones: 'Телефоны',
    workspace: 'Рабочее место',
    videos: 'Видео',
    distributions: 'Рассылки',
    posts: 'Посты',
    sources: 'Исходники',
    scenarios: 'Сценарии',
    machines: 'Машины',
    accounts: 'Аккаунты',
    directions: 'Направления',
    publications: 'Публикации',
    links: 'Ссылки',
    users: 'Пользователи',
    myClaude: 'Мой Claude',
    signOut: 'Выйти',
    serviceToken: 'сервисный токен',
    signedInAs: (email) => `Вы вошли как ${email}`,
    withToken: 'Вход по сервисному токену',
    lightTheme: 'Светлая тема',
    darkTheme: 'Тёмная тема',
    groupWork: 'Работа',
    groupSetup: 'Настройки',
    collapse: 'Свернуть меню',
    expand: 'Развернуть меню',
  },

  auth: {
    title: 'Ferma Hub',
    intro: 'Войдите рабочим аккаунтом, чтобы добраться до машин и телефонов на них.',
    email: 'Рабочая почта',
    password: 'Пароль',
    signIn: 'Войти',
    signingIn: 'Вход…',
    refused: 'Такая почта и пароль не приняты.',
    notConfigured: 'На сервисе ещё не настроен вход — обратитесь к администратору.',
    failed: (msg) => `не удалось войти: ${msg}`,
    corporateOnly: 'Только корпоративные аккаунты (@mornhouse.com). Парольные аккаунты создаёт администратор.',
    googleRefused: 'Google не подтвердил этот вход. Попробуйте ещё раз.',
    googleWrongDomain: 'Войдите корпоративным аккаунтом Google (@mornhouse.com).',
    usePassword: 'Войти по паролю',
  },

  devices: {
    notRecommended: (n: number) => `${n} пост. вне рекомендаций`,
    title: 'Телефоны',
    onlineOf: (online, total) => `${online} из ${total} доступны`,
    search: 'Модель, серийник, машина, аккаунт…',
    all: 'все',
    free: 'свободные',
    mine: 'мои',
    refresh: 'Обновить',
    nothing: 'Ничего не найдено.',
    hint: 'Телефон появляется здесь сам, как только его подключили к машине — регистрировать ничего не нужно.',
    open: 'открыть →',
    mySession: 'ваша сессия',
    busyFor: (min) => `занят ${min} мин`,
    busy: 'занят',
    offline: 'офлайн',
    error: (msg) => `ошибка: ${msg}`,
    statusOnline: 'Онлайн — можно подключаться',
    statusBusy: 'Занят — его держит кто-то другой',
    posting: 'публикация',
    statusPosting: 'Телефон держит автоматическая публикация; отобрать его нельзя',
    statusOffline: 'Офлайн — проверьте кабель и машину',
    adbTrouble: (state) => `adb: ${state}`,
    battery: (pct) => `${pct}%`,
    hot: (deg) => `${deg}°`,
    machineFilter: 'Машина',
    allMachines: 'все машины',
    directionFilter: 'Направление',
    allDirections: 'все направления',
    noDirection: 'без направления',
    noAccount: 'аккаунт TikTok не указан',
  },

  serviceKeys: {
    title: 'Ключи для других сервисов',
    sub: 'Ключ только на чтение для другого нашего сервиса, например учёта оборудования. Он читает и ничего не меняет.',
    name: 'Кто будет им пользоваться',
    namePh: 'Учёт оборудования',
    scopes: 'Что можно читать',
    create: 'Выпустить ключ',
    shownOnce: 'Ключ показывается один раз — скопируйте его, прежде чем уйти со страницы.',
    issued: 'Ключ — виден только сейчас',
    list: 'Выпущенные ключи',
    listSub: 'Отзовите ключ, и сервису с ним откажут со следующего же запроса.',
    none: 'Ключей ещё не выпускали.',
    by: (email: string) => `выпустил ${email}`,
    used: (at: string) => `последний раз ${at}`,
    neverUsed: 'ещё не использовался',
    revoke: 'Отозвать',
    remove: 'Удалить',
    live: 'действует',
    revoked: 'отозван',
    copy: 'копировать',
    confirmRevoke: 'Отозвать ключ? Сервису с ним откажут со следующего запроса.',
    confirmRemove: 'Удалить ключ? Он тоже будет отозван и больше никогда не сработает.',
    scope: {
      'read:hubs': 'компы — какие подключены и какие телефоны на каждом',
      'read:devices': 'телефоны — модель, статус, комп, аккаунт TikTok, кто держит',
    } as Record<string, string>,
  },
  myClaude: {
    title: 'Подключите своего Claude',
    sub: 'Ваш Claude работает здесь от вашего имени: видит машины и телефоны, берёт телефон на ваше имя и управляет им, загружает видео и исходники, создаёт и запускает посты и рассылки. Сценарии, телефоны, машины, пользователи и чужой контент остаются за вами в рабочем месте.',
    connectTitle: 'Подключение — без копирования ключа',
    connectSteps: [
      'В claude.ai, Claude Desktop или Claude Code добавьте коннектор с адресом ниже — без ключа и без заголовка.',
      'Нажмите Connect. Откроется страница Ferma Hub: проверьте, что там Claude, и нажмите «Разрешить».',
      'Готово — ваш Claude работает от вашего имени, а его ключ появится в списке ниже как любой другой.',
    ],
    connectNote: 'Claude Code: выполните команду ниже один раз, затем наберите /mcp, выберите ferma-hub и Authenticate — браузер откроет ту же страницу «Разрешить».',
    manualTitle: 'Ключ вручную — только для скриптов',
    manualSub: 'Ключ действует от вашего имени точно так же, как коннектор. Лучше Connect: нечего копировать, а отключение — один клик.',
    create: 'Выпустить ключ',
    shownOnce: 'Ключ показывается один раз — скопируйте его до ухода со страницы.',
    issued: 'Ваш ключ — виден только сейчас',
    web: 'Claude в браузере с ключом: Settings → Connectors → Add custom connector, URL выше, заголовок Authorization = Bearer <ваш ключ>.',
    code: 'Claude Code с ключом:',
    mine: 'Мои ключи и подключения',
    mineSub: 'Каждый подключённый Claude — строка здесь. Отзовите ключ, и этот Claude сразу перестанет работать.',
    none: 'Пока ничего не подключено.',
    revoke: 'Отозвать',
    remove: 'Удалить',
    live: 'действует',
    revoked: 'отозван',
    copy: 'копировать',
    confirmRevoke: 'Отозвать ключ? Ваш Claude перестанет работать с ним в течение минуты.',
    confirmRemove: 'Удалить ключ? Он тоже будет отозван и больше никогда не сработает.',
  },
  session: {
    openElsewhere: 'Этот телефон уже открыт в другой твоей вкладке.',
    showHere: 'Показать здесь',
    holdWarning: (s: number) => `Давно ничего не делалось — телефон освободится через ${s} с.`,
    keep: 'Оставить телефон',
    holdLeft: (min: number) => `ваш ещё ${min} мин без действий`,
    holdLeftTitle: 'Телефон освобождается через 10 минут без единого тапа, клавиши или установки от вас — любое действие сбрасывает счётчик',
    actions: 'Действия с телефоном',
    lapsed: 'Телефон мог освободиться из-за неактивности.',
    record: 'Записать сценарий',
    recording: 'Идёт запись… стоп',
    recordHint: 'Запись: пройдите весь путь публикации в TikTok сейчас. Воспроизведение начнётся с того экрана, на котором вы сейчас (домашний или открытое приложение). Касания чуть медленнее — хаб читает экран перед каждым.',
    recordStopped: (n) => `записано шагов: ${n}`,
    recordEmpty: 'ничего не записано',
    recordSaveTitle: 'Сохранить записанный сценарий',
    recordName: 'Название сценария',
    recordTextWarning: 'В записи есть ввод текста. Он будет напечатан один в один на каждом телефоне — уберите шаг с подписью, если это не нужно.',
    recordDiscard: 'Отбросить',
    expiredTitle: 'Ваша сессия завершилась',
    expiredBody: 'Сессии намеренно короткие. Пока вы не войдёте снова, здесь ничего не работает — нажмите OK, чтобы перейти ко входу.',
    expiredOk: 'OK',
    pickTitle: 'Выберите телефон слева',
    pickBody:
      'Здесь откроется живой экран: тап, свайп с настоящей скоростью, удержание, аппаратные клавиши, набор с вашей клавиатуры, звук, скриншоты — и лог телефона. Именно здесь присланное видео публикуют в TikTok вручную.',
    pickNote: 'Один телефон держит один человек: у него один экран, один аппаратный кодер и один поток ввода.',
    live: 'живой экран',
    starting: 'запуск',
    disconnect: 'Отключиться',
    close: 'Закрыть',
    disconnecting: 'Отключение…',
    busyBody: (who, forMin) =>
      `Этот телефон держит кто-то другой${who ? ` (${who})` : ''}${forMin ? `, уже ${forMin} мин` : ''}. Отобрать телефон ни у кого нельзя: он освободится сам, когда человек закончит или перестанет что-либо делать — выберите другой телефон.`,
    postingBody: (who) =>
      `На этом телефоне идёт автоматическая публикация${who ? ` (${who})` : ''} — она держит телефон, пока публикация не закончится; отобрать его нельзя.`,
    preemptedByPost:
      'Автоматическая публикация забрала этот телефон — это приоритетная задача. Телефон вернётся, когда публикация закончится; ничего вашего не потеряно.',
    failed: 'сессия не поднялась',
    retry: 'Попробовать ещё',
    endedOnServer: 'сессия завершена на сервере',
    hubStarting: 'машина поднимает поток…',
    startupNote: (elapsed, expected) =>
      `${elapsed} с · обычно около ${expected} с: сервис просит машину, та запускает scrcpy и ждёт управления и геометрии экрана`,
    notReady: 'экран ещё не готов',
    back: 'Назад',
    home: 'Домой',
    recents: 'Недавние',
    wake: 'Разбудить',
    power: 'Питание',
    volDown: 'Тише (на телефоне)',
    volUp: 'Громче (на телефоне)',
    swipeUp: 'Свайп вверх',
    swipeDown: 'Свайп вниз',
    screenshot: 'Скриншот',
    screenshotSaved: 'Скриншот сохранён',
    keyboard: 'Клавиатура',
    keyboardOn: 'Клавиатура: включена',
    keyboardHint: 'Нажатия идут на телефон. Esc = Назад. Выключите, чтобы печатать на этой странице.',
    keyboardTitle: 'Печатать прямо в телефон: буквы как текст, Enter/Backspace/стрелки как клавиши',
    typeHere: 'Набрать текст на устройстве…',
    send: 'Отправить',
    gestureHint: 'Клик = тап, перетаскивание = свайп с настоящей скоростью, удержание = долгий тап.',
    sessionId: 'Id сессии',
    video: 'Видео',
    quality: 'Качество',
    qualityTitle: 'Битрейт видео. Разрешение остаётся родным — иначе scrcpy теряет касания',
    q3: '3 Мбит · обычное',
    q5: '5 Мбит · чётче',
    q15: '1.5 Мбит · слабая связь',
  },

  audio: {
    title: 'Звук',
    on: 'Звук вкл.',
    off: 'Звук',
    toggleTitle: 'Звук с телефона — Opus, ~64 кбит/с',
    gain: 'Громкость воспроизведения в браузере (громкость самого телефона — клавиши ⊖ ⊕)',
    tone: 'бип',
    toneTitle: 'Проиграть 440 Гц прямо в выход браузера — чтобы отличить «браузер играет в другое место» от «декодер завис»',
    decoded: (n) => `декодировано ${n}/с`,
    ctx: (state) => `ctx=${state}`,
    gainValue: (v) => `gain ${v}`,
    fineHere: 'декодирует и играет — если тихо, проверьте устройство вывода на ноутбуке',
    noPackets: 'пакетов нет',
    starting: 'запуск (около 4 с)',
    quiet: 'тишина (телефон ничего не играет)',
    kbit: (n) => `${n} кбит/с`,
    noContext: 'браузер отказался открыть аудиоконтекст',
    noOpus: 'этот браузер не декодирует Opus (нужен Chrome/Edge)',
    decoderError: (msg) => `декодер: ${msg}`,
    outputError: (msg) => `вывод: ${msg}`,
    unavailable: 'звук недоступен',
    toneReport: (state, channels, chain) =>
      `тест: 440 Гц прямо в выход, ctx=${state}, ${channels} кан., ${chain}. Если не слышно — проверьте устройство вывода и системный микшер, а не телефон.`,
    chainGain: (v) => `gain канала ${v}`,
    chainClosed: 'канал не открыт',
  },

  input: {
    xiaomiSecurity: 'телефон не принимает тапы и клавиши с компьютера. На Xiaomi / Redmi / POCO: Настройки → Расширенные настройки → Для разработчиков → включи «Отладка по USB (Настройки безопасности)» (нужны SIM-карта и Mi-аккаунт), потом переподключи телефон',
    notDelivered: (label: string, hint: string) => `${label}: не доставлено — ${hint}`,
    channelDown: 'канал управления упал — переподключение',
    reconnecting: 'переподключаю канал управления…',
    touch_down: 'касание',
    touch_move: 'движение',
    touch_up: 'отпускание',
    tap: 'тап',
    swipe: 'свайп',
    text: 'текст',
    key: 'клавиша',
    sent: (label) => `${label} → телефон`,
    failed: (label) => `${label}: не дошло`,
    channelOpen: 'канал ввода открыт',
  },

  logs: {
    title: 'Лог телефона',
    needSession: 'откройте сессию, чтобы читать её лог',
    turnOn: 'Показать лог',
    turnOff: 'Скрыть лог',
    toggleTitle: 'Чтение лога занимает тот же USB-кабель, что тапы и видео — включается только по запросу',
    live: 'живой',
    closed: 'закрыт',
    packagePlaceholder: 'пакет (пусто = весь телефон)',
    packageLabel: 'Фильтр по пакету',
    matchPlaceholder: 'содержит…',
    matchLabel: 'Фильтр по тексту',
    apply: 'Применить',
    clear: 'Очистить',
    follow: 'следить',
    waiting: 'жду первые строки…',
    started: (pkg, match, replaying) =>
      `--- лог запущен · ${pkg ? `пакет ${pkg}` : 'весь телефон'}${match ? ` · содержит «${match}»` : ''}${replaying ? ` · воспроизвожу до ${replaying} строк, которые ещё держит телефон` : ''}`,
    hint: 'Ваши тапы и клавиши подсвечены (▸). Краши и ANR остаются всегда, кто бы их ни записал.',
    offHint: 'Лог выключен. Включите, чтобы видеть, что делает приложение, пока вы управляете телефоном — он подгрузит то, что телефон ещё помнит.',
  },

  videos: {
    results: 'Что принесло',
    viewsWord: 'просм.',
    likesWord: 'лайк.',
    postsAccounts: (posts: number, accounts: number) => `${posts} пост. с ${accounts} аккаунт.`,
    lastPosted: (when: string) => `последний ${when}`,
    history: (n: number) => `история · ${n}`,
    bestPost: (views: string) => `лучший: ${views}`,
    neverPosted: 'ещё нигде не публиковалось',
    orderNew: 'Новые',
    orderBest: 'Что стреляет',
    orderNever: (n: number) => `Ещё не постилось · ${n}`,
    notReadYet: 'цифр ещё нет',
    openPost: 'открыть пост',
    noLink: 'без ссылки',
    directionFor: 'Направление для загрузки…',
    pickDirectionFirst: 'Сначала выберите направление — видео принадлежит одному направлению и пойдёт только на его телефоны.',
    noDirectionsYou: 'У вас ещё нет направления — админ добавляет его на странице «Пользователи»',
    direction: 'Направление',
    setDirection: 'указать направление…',
    moveDirection: 'изменить…',
    noDirection: 'без направления — никуда не пойдёт',
    allDirections: (n: number) => `Все · ${n}`,
    withoutDirection: (n: number) => `Без направления · ${n}`,
    title: 'Видео',
    sub: 'Загрузите один раз — затем разошлите на любые машины и телефоны',
    upload: 'Загрузить видео',
    dropTitle: 'Перетащите .mp4 / .mov / .webm сюда или нажмите, чтобы выбрать',
    dropBody: 'Большие файлы идут частями по 8 МБ и продолжаются после обрыва связи.',
    hashing: 'считаю контрольную сумму…',
    uploaded: (name) => `${name} загружено`,
    rejected: 'сервер отклонил файл (не совпала контрольная сумма)',
    deleted: (name) => `${name} удалено`,
    readError: (msg) => `не удалось прочитать список видео: ${msg}`,
    none: 'видео пока нет',
    file: 'файл',
    size: 'размер',
    state: 'состояние',
    uploadedBy: 'загружено',
    titleLabel: 'Название видео',
    renameTitle: 'Нажмите, чтобы дать видео название; оно показывается вместо имени файла. Пустое — возвращает имя файла.',
    renamed: (name) => `теперь называется ${name}`,
    status: { uploading: 'загружается', ready: 'готово', error: 'ошибка' },
    distribute: 'Разослать',
    download: 'Скачать',
    delete: 'Удалить',
    deleteTitle: (name) => `Удалить ${name}?`,
    deleteBody: 'Файл убирается с сервера. Копии, уже лежащие на телефонах, остаются; идущая рассылка блокирует удаление.',
  },

  distribute: {
    otherDirection: 'телефон другого направления — видео пойдёт только на телефоны своего направления',
    noDirectionPhone: 'без направления',
    title: (name) => `Разослать ${name}`,
    body: 'Каждая машина скачивает файл один раз и копирует его в галерею каждого выбранного телефона (Movies/TikTokHub). Публикацию в TikTok затем делают на телефоне, с его живого экрана.',
    loading: 'ищу машины…',
    phonesOnline: (online, total) => `${online} из ${total} телефонов онлайн`,
    allOnline: 'все телефоны онлайн',
    someOf: (n, total) => `${n} из ${total} телефонов`,
    send: (machines) => (machines === 1 ? 'Отправить на 1 машину' : `Отправить на ${machines} машин`),
    sending: 'Отправляю…',
    started: (machines) => `Рассылка запущена на ${machines} машин(е)`,
    uniquify: 'Уникализировать для каждого телефона',
    uniquifyHint: 'каждый телефон получает свой вариант: 25–30 % срезано сверху или снизу, на этом месте фон и полупрозрачный клип-оверлей',
    capacity: (phones, capacity) => `${phones} телефонов · исходников хватит на ${capacity}`,
    notEnoughSources: (needed, available) =>
      `${needed} телефонам нужно ${needed} разных вариантов, а исходников хватает только на ${available} — загрузите ещё оверлеев или фонов либо выберите меньше телефонов`,
    delaysHint: 'Отправка идёт с разбросом: до 5 мин между машинами, до 10 мин между телефонами одной машины.',
    card: 'Заставка',
    cardHint: 'статичная картинка (ваше лого) на несколько секунд в каждом варианте',
    cardNone: 'без заставки',
    cardUpload: 'Загрузить заставку…',
    cardPlacement: { start: 'в начале', end: 'в конце', both: 'в начале и в конце' },
    cardSeconds: 'секунд',
    publish: 'Опубликовать в TikTok после доставки',
    publishWith: (name) => `активный сценарий: ${name}`,
    publishNone: 'нет активного сценария — публикации не будет; запишите его из живой сессии',
    cardRetention: 'Заставка в начале стоит просмотров: первые 1–2 секунды решают, пролистнут ли ролик. Лучше в конец, либо интро короче 2 с.',
  },

  distributions: {
    title: 'Рассылки',
    sub: 'Каждая отправка видео на машины и телефоны, новые сверху',
    readError: (msg) => `не удалось прочитать рассылки: ${msg}`,
    none: 'пока ничего не рассылали',
    video: 'видео',
    machines: 'машины',
    phones: 'телефоны',
    state: 'состояние',
    started: 'запущена',
    doneOf: (done, total) => `${done}/${total} готово`,
    failed: (n) => `${n} не удалось`,
    status: { running: 'идёт', done: 'готово', partial: 'частично', error: 'не удалось', cancelled: 'остановлена' },
    target: { pending: 'ожидает', pushing: 'отправляется', done: 'на телефоне', error: 'не удалось', cancelled: 'отменено' },
    uniquify: 'Уникализация',
    variant: { queued: 'вариант в очереди', rendering: 'рендер', done: 'вариант готов', error: 'вариант не удался', none: '', cancelled: 'рендер отменён' },
    attempt: (n) => `попытка ${n}`,
    rendering: (n) => `${n} в рендере`,
    variantsFailed: (n) => `${n} не удалось после 3 попыток`,
    publishTitle: 'Публикация',
    publishState: { none: '', waiting: 'публикация ждёт', running: 'публикуется…', done: 'опубликовано', error: 'публикация не удалась', skipped: 'не публиковалось', cancelled: 'публикация отменена', by_hand: 'ждёт, пока Claude опубликует', unconfirmed: 'опубликовано? ещё не видели', not_found: 'нет в профиле' },
    unconfirmedTitle: 'Сценарий выполнил свои тапы, но чтение профиля ещё не видело этот пост. «Опубликовано» будет, когда профиль его покажет (чтение — примерно через час после поста).',
    byHandTitle: 'Запущено через Claude: видео на телефоне, и Claude публикует его сам, глядя на экран, — без сценария вслепую. «Опубликовано» — когда Claude записал ссылку.',
    byClaude: 'публикует Claude, глядя на экран',
    openPost: 'открыть пост ↗',
    publishIn: (s) => (s >= 60 ? `публикация через ${Math.ceil(s / 60)} мин` : `публикация через ${s} с`),
    publishFailedAt: (step) => `сбой на шаге ${step + 1}`,
    publishScreenshot: 'экран в момент сбоя',
    publishRetry: 'Опубликовать ещё раз',
    release: 'Отпустить',
    released: (name: string) => `${name}: отпущено — доставка началась`,
    heldNote: 'на паузе — посмотрите варианты и отпустите',
    viewVariant: 'посмотреть вариант',
    retryPush: 'Доставить ещё раз',
    pushRetried: (device: string, n: number, of: number) => `доставляю на ${device} ещё раз (попытка ${n} из ${of})`,
    pushTries: (n: number, of: number) => `повторов доставки: ${n} из ${of}`,
    pushTriesUsed: 'попытки исчерпаны — посмотрите телефон, потом новый пост',
    publishRetried: (device) => `публикация запущена снова на ${device}`,
    publishLog: 'лог публикации',
    releaseIn: (s) => (s >= 60 ? `отправка через ${Math.ceil(s / 60)} мин` : `отправка через ${s} с`),
    stop: 'Остановить',
    stopTitle: (name) => `Остановить рассылку ${name}?`,
    stopBody: 'Рендеры снимаются с очереди, текущий ffmpeg убивается, на телефоны больше ничего не уйдёт. То, что уже на телефонах, остаётся. Отменить это нельзя.',
    stopped: (name) => `рассылка ${name} остановлена`,
    delete: 'Удалить',
    deleteTitle: (name) => `Удалить рассылку ${name} из списка?`,
    deleteBody: 'Пропадёт только запись о рассылке. Видео и его варианты остаются.',
    deleted: (name) => `рассылка ${name} удалена`,
    back: '← Все рассылки',
    showLog: 'лог машины',
    hideLog: 'скрыть лог',
    emptyLog: '(машина ещё ничего не напечатала)',
  },

  scenarios: {
    title: 'Сценарии публикации',
    sub: 'Что человек сделал один раз в живой сессии; каждый телефон повторяет это после доставки видео',
    rule: 'Запись делается из Рабочего места: откройте телефон, выйдите на домашний экран (или в TikTok), нажмите «Записать сценарий», пройдите весь путь публикации, остановите, назовите. Воспроизведение начинается с того экрана, где началась запись. Активен ровно один сценарий — он запускается в каждой рассылке. Не печатайте настоящую подпись во время записи: она уйдёт один в один на все телефоны. Напечатайте слово-заглушку и отметьте этот шаг как подпись; пост без подписи его пропускает.',
    readError: (msg) => `не удалось прочитать сценарии: ${msg}`,
    none: 'сценариев пока нет — запишите из живой сессии',
    active: 'активный',
    activate: 'Сделать активным',
    deactivate: 'Снять',
    steps: (n) => `шагов: ${n}`,
    recordedOn: (d) => `записан на ${d}`,
    tryOn: 'Проверить на телефоне',
    tryPick: 'выберите телефон…',
    tryStarted: (device) => `сценарий запущен на ${device}`,
    tryLog: 'лог запуска',
    rename: 'Переименовать',
    delete: 'Удалить',
    deleteTitle: (name) => `Удалить сценарий ${name}?`,
    deleteBody: 'Уже идущие рассылки сохраняют свою копию.',
    deleted: (name) => `${name} удалён`,
    saved: (name) => `${name} сохранён`,
    hasText: 'есть ввод текста',
    captionStep: 'шаг подписи',
    markCaption: 'это подпись',
    unmarkCaption: 'не подпись',
    captionHint: 'Отметьте текстовый шаг, где печатается подпись: пост вставит туда свой текст вместо записанного. Без отметки пост с подписью не запустится; пост без подписи пропускает этот шаг.',
    captionMarked: 'шаг подписи задан',
    stepKinds: { tap: 'тап', swipe: 'свайп', text: 'текст', key: 'клавиша', wait: 'пауза', launch: 'запуск', stop: 'стоп' },
  },

  posts: {
    notYoursEditor: 'Этот пост создал кто-то другой: изменить его может только владелец или администратор.',
    title: 'Посты',
    sub: 'Видео, анимированный баннер, подпись, уникализация, телефоны — готовится один раз, запускается один раз',
    none: 'постов пока нет — выберите готовое видео, чтобы начать',
    wizard: {
      title: 'Шаги поста',
      video: 'Видео и подпись',
      optional: 'необязательно',
      done: 'готово',
      needVideo: 'выберите видео',
      needText: 'напишите подпись',
      needPhones: 'выберите телефоны',
      needCheck: 'нажмите «Проверить»',
    },
    newPick: 'Новый пост из видео…',
    video: 'Видео',
    text: 'Подпись',
    textPlaceholder: 'Необязательно. Текст поста: хештеги, эмодзи, любой язык…',
    phones: 'Телефоны',
    phonesSub: 'Каждый телефон получает свой уникализированный вариант с баннером, затем активный сценарий публикует его с этой подписью',
    phone: 'телефон',
    stage: 'этап',
    banner: 'Баннер',
    bannerNone: 'без баннера',
    bannerUpload: 'Загрузить баннер…',
    bannerHint: '.webm / .mov / .gif с прозрачностью, накладывается на готовый кадр — поверх полосы тоже, поэтому никогда не срезается. Вписывается в свою область с сохранением пропорций — не растягивается и не обрезается — и крепится к верхнему или нижнему краю.',
    box: { width: 'ширина', height: 'высота', anchor: 'край', margin: 'отступ от края', top: 'сверху', bottom: 'снизу' },
    strip: {
      title: 'Уникализация',
      sub: 'У каждого телефона из кадра срезается полоса и заполняется фоном с полупрозрачным клипом-оверлеем. Каждый телефон берёт свои значения внутри этих диапазонов.',
      side: 'сторона среза',
      sides: { top: 'сверху', bottom: 'снизу', random: 'случайно на телефон' },
      height: 'высота полосы',
      opacity: 'прозрачность оверлея',
      min: 'мин',
      max: 'макс',
      rangeHint: 'Одинаковые мин и макс фиксируют значение на всех телефонах. Предпросмотр показывает максимальную высоту и прозрачность, и верх — когда сторона случайна.',
      exampleOverlay: 'оверлей для предпросмотра',
      exampleBackground: 'фон для предпросмотра',
      exampleDefault: (name) => `самый ранний (${name})`,
      exampleNone: 'ещё ничего не загружено',
      exampleHint: 'Только для предпросмотра: телефоны берут свою пару оверлей + фон из всего каталога.',
      sound: 'Звук',
      pitch: 'сдвиг высоты тона',
      music: 'громкость музыки',
      soundHint: 'Тон сдвигается вверх или вниз на случайную величину из диапазона, длина не меняется. Музыка — случайный тихий кусок случайного загруженного трека; 0–0 = без музыки.',
      reset: 'Вернуть по умолчанию',
    },
    cardSub: 'Статичная картинка (ваше лого) на несколько секунд в начале и/или в конце каждого варианта. Заставки загружаются на странице исходников.',
    preview: 'Предпросмотр',
    previewHint: 'Точный кадр: то, что попадёт в финальный файл, с полосой максимальной высоты из исходников для предпросмотра. В движении: полоса и баннер анимируются поверх видео в браузере.',
    previewFrame: 'точный кадр',
    previewMotion: 'в движении',
    previewAt: 'на',
    previewLoading: 'рендерим кадр…',
    previewNoVideo: 'выберите видео, чтобы увидеть предпросмотр',
    previewCaption: 'подпись, как её покажет TikTok (не часть файла)',
    overlayTitle: 'Текст на видео',
    overlaySub: 'Вжигается в картинку на каждом телефоне. Отдельно от подписи.',
    overlayNone: 'без текста на видео',
    overlayOn: 'добавить текст на видео',
    overlayText: 'Текст',
    overlayFromCaption: 'Взять из подписи',
    overlayBox: { nx: 'по горизонтали', ny: 'по вертикали', size: 'размер', width: 'макс. ширина' },
    overlayColor: 'цвет текста',
    overlayBackground: 'подложка',
    overlayBackgroundOpacity: 'прозрачность подложки',
    editTitle: 'Черновик поста',
    editSub: 'Сохраняется по ходу правки; ничего не отправляется до кнопки «Запустить»',
    save: { saved: 'сохранено', saving: 'сохранение…', dirty: 'не сохранено' },
    launchCard: 'Запуск',
    check: 'Проверить',
    launch: 'Запустить',
    launchTitle: (n) => `Опубликовать на ${n} телефонах?`,
    launchHeld: 'Запустить с просмотром',
    launchHeldBody: 'Варианты отрендерятся и будут ждать: откройте вариант каждого телефона в рассылке, потом «Отпустить» — до этого ничего не доставляется.',
    launchBody: 'Черновик фиксируется как есть. Каждый телефон получает свой вариант, затем активный сценарий публикует его с подписью. Это происходит один раз; неудавшийся телефон можно опубликовать снова вручную.',
    launched: (machines) => `Пост запущен на ${machines} машин(е/ах)`,
    launchedTitle: 'Запущенный пост',
    readyToLaunch: (n, scenario) => `Готово: ${n} телефонов, сценарий «${scenario}».`,
    openDistribution: 'Открыть рассылку',
    status: { draft: 'черновик', launched: 'запущен' },
    stages: { rendering: 'рендер', ready: 'готов', pushing: 'доставка', waiting: 'на телефоне, пауза перед публикацией', unconfirmed: 'ещё не видели', publishing: 'публикация', done: 'готово', error: 'ошибка', cancelled: 'остановлен', by_hand: 'ждёт Claude', not_posted: 'не опубликовано' },
    failedAt: { rendering: 'рендер не удался', pushing: 'доставка не удалась', publishing: 'публикация не удалась' },
    failedCount: (n) => `${n} с ошибкой`,
    problems: {
      post_two_sites: 'в посте ссылки на два разных сайта — один аккаунт ведёт только на один сайт; оставьте один',
      account_other_site: 'эти аккаунты уже ведут на другой сайт — один аккаунт ведёт только на один сайт',
      phone_unreachable: 'компьютер не видит эти телефоны (offline или adb unauthorized) — уберите их или подтвердите «Разрешить отладку по USB» на телефоне',
      video_no_direction: 'у видео нет направления — укажите его на странице «Видео»',
      phone_other_direction: 'телефоны другого направления — видео пойдёт только на телефоны своего направления',
      account_banned: 'аккаунт в бане — не постит',
      account_limited: 'аккаунт ограничен — не постит, пока снова не станет активным',
      daily_limit: 'аккаунт уже выложил свой лимит за сутки (3 поста, на прогреве — 1)',
      too_soon: 'аккаунт постил меньше 2 часов назад',
      no_directions: 'у вас ещё нет направления — админ добавляет его на странице «Пользователи»',
      not_your_direction: 'это видео другого направления, чем ваши',
      video_not_ready: 'видео отсутствует или ещё не загружено',
      banner_not_ready: 'баннер отсутствует или ещё не загружен',
      no_targets: 'выберите хотя бы одну машину или телефон',
      no_devices: 'ни один из выбранных телефонов не в сети',
      not_enough_sources: 'слишком мало пар оверлей × фон для стольких телефонов — загрузите исходники или выберите меньше телефонов',
      no_scenario: 'нет активного сценария публикации',
      no_caption_step: 'в активном сценарии не отмечен шаг подписи (Сценарии → «это подпись»)',
      hub_offline: 'выбранная машина не в сети',
      device_not_on_hub: 'выбранный телефон не на этой машине',
    },
    delete: 'Удалить',
    deleteTitle: 'Удалить этот пост?',
    deleteBody: 'У запущенного поста рассылка остаётся; удаляется только запись поста.',
    deleted: 'пост удалён',
  },

  sources: {
    groupVariant: 'Уникализация — каждый телефон получает свой вариант видео',
    groupPost: 'Оформление постов — выбирается для каждого поста или рассылки',
    title: 'Исходники для уникализации',
    sub: 'Что подмешивается в вариант каждого телефона: оверлеи и фоны для полосы, музыка под звук, заставки на выбор',
    rule: 'Вариант = один клип-оверлей на одном фоне (сторона среза и прозрачность добавляются случайно). Каждый телефон одной рассылки получает свою пару; следующее видео снова берёт весь каталог. Ёмкость — на сколько телефонов хватит одной рассылки. Музыка не считается: случайный тихий кусок случайного трека подкладывается под каждый вариант автоматически.',
    capacity: (n) => `хватит на ${n} телефонов`,
    readError: (msg) => `не удалось прочитать исходники: ${msg}`,
    kind: { overlay: 'Клипы-оверлеи', background: 'Фоны', music: 'Музыка', card: 'Заставки', banner: 'Баннеры' },
    kindHint: {
      overlay: 'короткие .mp4 / .mov / .webm, зациклены и наложены на полосу с прозрачностью, заданной в посте (по умолчанию 55–75 %)',
      background: '.jpg / .png, заполняет срезанную полосу под оверлеем',
      music: '.mp3 / .m4a / .wav — случайный кусок на 2–5 % громкости с плавным началом и концом под каждым вариантом; используйте свободные от прав треки',
      card: '.jpg / .png, ваше лого на чёрном; выбирается в диалоге Distribute или в редакторе поста',
      banner: '.webm / .mov / .gif с прозрачностью — анимированный клип, который пост кладёт поверх кадра; размещается и настраивается в редакторе поста',
    },
    none: { overlay: 'клипов-оверлеев пока нет', background: 'фонов пока нет', music: 'музыки пока нет — у вариантов остаётся только исходный звук', card: 'заставок пока нет', banner: 'баннеров пока нет' },
    upload: 'Загрузить',
    files: (n: number) => `${n} ${n % 10 === 1 && n % 100 !== 11 ? 'файл' : [2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100) ? 'файла' : 'файлов'}`,
    uploaded: (name) => `${name} загружено`,
    delete: 'Удалить',
    deleted: (name) => `${name} удалено`,
    deleteTitle: (name) => `Удалить ${name}?`,
    deleteBody: 'Уже отрендеренные варианты остаются; новые рассылки его не используют, ёмкость уменьшится.',
  },

  account: {
    label: 'Аккаунт TikTok на этом телефоне',
    placeholder: '@аккаунт',
    none: 'указать аккаунт TikTok',
    editTitle: 'Какой аккаунт TikTok залогинен на этом телефоне. Только метка — один аккаунт живёт на одном телефоне.',
    set: (account, phone) => `${account} теперь на ${phone}`,
    cleared: (phone) => `метка аккаунта снята с ${phone}`,
    inUse: (account, device) => `${account} уже на ${device} — один аккаунт живёт на одном телефоне`,
  },

  simNumber: {
    label: 'Номер SIM в этом телефоне',
    placeholder: '+380 67 123 45 67',
    none: 'добавить номер',
    editTitle: 'Номер SIM-карты в этом телефоне, чтобы было видно сразу. Один номер — один телефон.',
    set: (num, phone) => `${num} теперь на ${phone}`,
    cleared: (phone) => `номер убран с ${phone}`,
    inUse: (num, device) => `${num} уже на ${device} — одна SIM, один телефон`,
  },

  phoneName: {
    label: 'Название телефона',
    editTitle: 'Нажмите, чтобы назвать телефон; название показывается вместо модели везде. Пустое — возвращает модель.',
    set: (name, model) => `${model} теперь называется ${name}`,
    cleared: (model) => `${model} снова показывается по модели`,
  },

  accountPage: {
    site: 'Сайт',
    siteNone: 'ещё не закреплён — его задаст первый пост со ссылкой',
    siteChange: 'изменить',
    siteSave: 'Сохранить',
    siteCancel: 'Отмена',
    siteBy: (by: string) => `закрепил: ${by}`,
    siteConfirm: (from: string, to: string) => `Этот аккаунт уже ведёт на ${from}, и его посты там и останутся. Всё равно сменить на ${to || 'ничего'}? Один аккаунт — один сайт.`,
    unknown: 'Такого аккаунта нет — возможно, ссылка устарела.',
    openPhone: 'Открыть телефон',
    onPhone: (phone: string) => `на телефоне ${phone}`,
    profile: 'профиль в TikTok',
  },
  direction: {
    unknown: 'Такого направления нет.',
    tabs: { stats: 'Статистика', accounts: 'Аккаунты', posts: 'Публикации', links: 'Ссылки', phones: 'Телефоны' } as Record<string, string>,
  },
  trend: {
    dayChange: (d: string) => `за день ${d}`,
    lastDay: (day: string) => `${day} за день:`,
    bestDay: (day: string, v: string) => `лучший день — ${day}: ${v}`,
    firstReading: (day: string) => `первое чтение — ${day}; линия будет расти каждый день, прошлых дней TikTok не показывает`,
    notRead: 'ещё не прочитано',
    since: (day: string) => `с ${day}`,
    overDays: (n: number) => `за ${n} дн.`,
  },
  sections: {
    directions: 'Направления',
    accounts: 'Все аккаунты',
    publications: 'Все публикации',
    links: 'Ссылки',
    posts: 'Запуск постов',
    distributions: 'Рассылки',
    videos: 'Видео',
    machines: 'Машины',
    sources: 'Источники',
    scenarios: 'Сценарии',
    users: 'Пользователи',
    myClaude: 'Мой Claude',
    keys: 'Ключи',
  },
  dirs: {
    title: 'Направления',
    sub: 'что рекламируем — и какие телефоны на кого работают',
    rules: [
      'Направление — это то, что рекламируем: игры, дорамы и т. д. Дашборд, отчёты и контент разложены по направлениям.',
      'Каждый телефон принадлежит одному направлению навсегда, вместе со всеми аккаунтами на нём: с него постят только контент этого направления.',
      'Телефон без направления маркетинг не использует: его не читает статистика и он не попадает в отчёты. Играть на нём и брать сессии можно как обычно.',
      'Направление можно переименовать и перекрасить когда угодно; привязку телефона изменить нельзя.',
    ],
    newName: 'Название нового направления, напр. Казино',
    color: 'Цвет',
    add: 'Добавить направление',
    edit: 'Переименовать / цвет',
    save: 'Сохранить',
    cancel: 'Отмена',
    counts: (phones: number, accounts: number) => `телефонов: ${phones} · аккаунтов: ${accounts}`,
    noPhones: 'Телефонов пока нет — привяжите их ниже, в «Без направления».',
    noAccounts: 'аккаунтов не зарегистрировано',
    status: { online: 'на связи', offline: 'не на связи', busy: 'занят' } as Record<string, string>,
    unboundTitle: (n: number) => `Без направления · ${n}`,
    allBound: 'У всех телефонов есть направление.',
    unboundSub: 'эти телефоны маркетинг не использует, пока админ не привяжет их к направлению',
    unboundSubAdmin: 'отметьте телефоны, выберите направление и привяжите — все сразу',
    pickAll: 'Отметить все',
    pickNone: 'Снять все',
    toDirection: 'к направлению…',
    bind: (n: number) => `Привязать (${n})`,
    confirmTitle: (n: number, dir: string) => `Привязать ${n} тел. к «${dir}» навсегда`,
    confirm: 'Привязать навсегда',
  },
  marketing: {
    builtin: { games: 'Игры', dramas: 'Драмы' },
    title: 'Аккаунты',
    sub: 'аккаунты в телефонах по направлениям — кто жив, ограничен или в бане',
    rules: 'Телефон принадлежит одному направлению навсегда (привязывает админ на странице «Направления»). Аккаунт живёт в одном телефоне навсегда и не удаляется — пропавший отмечают «вышел». Паролей нигде нет.',
    allDirections: 'Все направления',
    noBoundPhones: 'Ни у одного телефона ещё нет направления — сначала админ привязывает их на странице «Направления».',
    emailPlaceholder: 'почта, с которой вошли (name@gmail.com)',
    handlePlaceholder: '@ник (необязательно)',
    handleOnly: '@ник или ссылка на профиль',
    addHandle: '+ ник',
    phone: 'Телефон',
    pickPhone: 'телефон…',
    stateLabel: 'Состояние',
    add: 'Добавить аккаунт',
    state: { warming: 'прогрев', active: 'активен', limited: 'ограничен', banned: 'бан', logged_out: 'вышел' } as Record<string, string>,
    changeState: 'изменить состояние…',
    reasonRequired: 'что увидели — обязательно',
    reasonOptional: 'что увидели (необязательно)',
    save: 'Сохранить',
    history: (n: number) => `история · ${n}`,
    groupSub: (phones: number, accounts: number) => `телефонов: ${phones} · аккаунтов: ${accounts}`,
    noPhonesInDirection: 'в этом направлении ещё нет телефонов',
    noAccounts: 'на этом телефоне аккаунтов не зарегистрировано',
    noDirection: 'без направления',
    noDirectionTitle: 'ещё не привязан к направлению — маркетинг не может им пользоваться, пока админ не привяжет',
    bindButton: 'Назначить направление',
    bindTitle: (phone: string) => `Привязать ${phone} к направлению`,
    bindPick: 'Выберите направление',
    bindConfirm: (_dir: string) => 'Привязать навсегда',
    bindForever: 'Это навсегда: телефон и все аккаунты на нём будут принадлежать этому направлению. Изменить можно будет только правкой базы.',
    bindOnlyMarketing: 'Это ограничивает только маркетинг — телефон по-прежнему берёт сессии, и Claude может играть на нём в игры.',
    directionsTitle: 'Направления',
    directionsSub: 'только для админов: добавить направление и видеть, что в каждом',
    directionStats: (phones: number, accounts: number) => `телефонов: ${phones} · аккаунтов: ${accounts}`,
    newId: 'id, напр. apps',
    newName: 'название',
    color: 'цвет',
    preview: 'вид',
    addDirection: 'Добавить направление',
  },
  publications: {
    title: 'Публикации',
    sub: 'каждый пост на каждом телефоне — постинг Фермы появляется здесь сам; посты, сделанные вручную или Claude, записываются через MCP',
    all: 'Все',
    noLink: 'Без ссылки',
    noAccount: 'Аккаунт неизвестен',
    summary: (n: number, noLink: number, noAccount: number) => `${n} пост. · ${noLink} без ссылки · ${noAccount} с неизвестным аккаунтом`,
    empty: 'Пока ничего. Завершённый постинг появляется здесь в течение минуты.',
    day: (n: number) => `${n} пост.`,
    video: 'видео',
    text: 'текст',
    source: { ferma: 'постинг Фермы', recorded: 'записано', profile: 'найдено в профиле' },
    accountBy: { phone: 'единственный аккаунт на этом телефоне', link: 'из ссылки на пост', person: 'указал человек' },
    pickAccount: 'Какой аккаунт?',
    noAccounts: 'на этом телефоне нет зарегистрированных аккаунтов',
    addLink: 'Добавить ссылку на пост',
    linkPlaceholder: 'https://www.tiktok.com/@handle/video/…',
    open: 'Открыть пост',
    save: 'Сохранить',
    cancel: 'Отмена',
    onWords: 'на видео',
    phoneGone: 'телефон больше не подключён',
    noTarget: 'Без цели',
    onlyLink: (name: string) => `Только посты со ссылкой ${name}.`,
    showAll: 'Показать все',
    target: 'Ссылка',
    targetFromText: 'из текста поста',
    targetByPerson: 'указал человек',
    targetReset: 'брать из текста',
    pickTarget: 'Какая ссылка в посте?',
    noTargets: 'список ссылок пуст — админ добавляет их на странице «Ссылки»',
  },

  dash: {
    phonesCount: (n) => `на ${n} телефонах`,
    title: 'Обзор',
    sub: 'всё, что делает ферма, и что принесли посты',
    updated: (at) => `обновлено ${at}`,
    periods: { 1: 'Сегодня', 7: '7 дней', 30: '30 дней', 90: '90 дней', 365: 'Год' } as Record<number, string>,
    daysN: (n: number) => `${n} дн.`,
    customDates: 'Свои даты',
    from: 'с',
    to: 'по',
    accountsTrendsTitle: (n: number) => `Аккаунты по дням · ${n}`,
    accountsTrendsSub: 'каждый аккаунт: подписчики, просмотры постов и лайки каждый вечер; название открывает аккаунт',
    postsInPeriod: (n: number) => `постов за период: ${n}`,
    allDirections: 'все направления',
    noDirection: 'телефоны без направления',
    allPhones: 'все телефоны',
    phonePage: (name) => `Телефон ${name}`,
    backToAll: 'Назад ко всей ферме',
    openPhone: 'Открыть телефон',
    nowTitle: 'Сейчас',
    nowSub: 'вся ферма, независимо от фильтра',
    phonesTile: 'Телефоны',
    phoneStates: { free: 'свободны', posting: 'постят', held: 'держит человек / Claude', reading: 'читают статистику', offline: 'не на связи', trouble: 'подключены, но недоступны' },
    machinesTile: 'Машины',
    machinesOnline: (on, all) => `${on} из ${all} на связи`,
    distributionsTile: 'Рассылки',
    distRunning: (n) => `${n} в работе`,
    distFinished: (done, partial, err) => `за 24 ч: ${done} готово · ${partial} частично · ${err} с ошибкой`,
    jobsTile: 'Задания на телефонах',
    jobsLine: (run, queued) => `${run} выполняется · ${queued} в очереди`,
    jobsDay: (done, failed) => `за 24 ч: ${done} готово · ${failed} с ошибкой`,
    passTile: 'Чтение профилей',
    passOn: 'расписание включено',
    passOff: 'расписание выключено',
    passRunning: (who) => `читает ${who}`,
    passDay: (n) => `${n} чтений за 24 ч`,
    heldTitle: 'Кто какой телефон держит',
    heldFor: (min) => `${min} мин`,
    heldPosting: 'автопостинг',
    heldReading: 'читает статистику — можно брать',
    runningTitle: 'Рассылки в работе',
    pushed: (done, all) => `залито ${done}/${all}`,
    rendered: (done, all) => `уникализировано ${done}/${all}`,
    published: (done, all, failed) => `опубликовано ${done}/${all}${failed ? ` · ${failed} с ошибкой` : ''}`,
    nothingRunning: 'Сейчас ничего не рассылается.',
    nobodyHolds: 'Сейчас никто не держит телефон.',
    alertsTitle: 'Требует внимания',
    alertsNone: 'Всё в порядке — ничего не требует внимания.',
    more: (n) => `и ещё ${n}`,
    alert: {
      not_recommended: (n) => `TikTok не показывает в рекомендациях («Для вас»): ${n} пост(ов) — органического охвата нет`,
      hubs_offline: (n) => `Машин не на связи: ${n}`,
      phones_offline: (n) => `Телефонов не на связи: ${n}`,
      phones_trouble: (n) => `Подключены, но недоступны (adb): ${n}`,
      battery_low: (n) => `Почти разряжены и не заряжаются: ${n}`,
      battery_weak_power: (n) => `На кабеле, который не заряжает: ${n}`,
      hot: (n) => `Перегреваются: ${n}`,
      accounts_banned: (n) => `Аккаунтов в бане: ${n}`,
      accounts_limited: (n) => `Ограниченных аккаунтов: ${n}`,
      profile_trouble: (n) => `Последнее чтение профиля нашло проблему: ${n} аккаунт(ов)`,
      distributions_failed: (n) => `Рассылок за 24 ч, опубликованных не везде: ${n}`,
      jobs_failed: (n) => `Заданий на телефонах с ошибкой за 24 ч: ${n}`,
      doubtful: (n) => `Посты, сопоставленные не наверняка, — решает человек: ${n} аккаунт(ов)`,
      not_found: (n) => `Постов Фермы нет в профиле: ${n} аккаунт(ов)`,
      phones_unbound: (n) => `Телефонов без направления (не читаются, не считаются): ${n}`,
      phones_no_account: (n) => `Телефонов с направлением, но без аккаунта: ${n}`,
      accounts_no_email: (n) => `Аккаунтов без почты: ${n}`,
      posts_no_link: (n) => `Постов без целевой ссылки: ${n}`,
      posts_no_account: (n) => `Постов без аккаунта: ${n}`,
      links_unlisted: (n) => `Адресов в постах, которых нет в списке ссылок: ${n}`,
      accounts_two_sites: (n: number) => `${n} аккаунт(а) уже ведут на два разных сайта — так быть не должно`,
      links_shared: (n) => `Ссылок на многих телефонах — нить, связывающая аккаунты: ${n}`,
      pass_off: () => 'Расписание чтения профилей выключено — цифры обновляются только вручную',
    },
    dirPeriodTitle: (period) => `По направлениям · ${period}`,
    dirPeriodSub: 'посты, вышедшие за период, и сколько за него прибавилось просмотров, лайков и подписчиков — в сравнении с отрезком перед ним; аккаунты с проблемами — на сейчас',
    lineSince: (day, now) => `сейчас ${now} · читаем с ${day}, линия — после 3 дней`,
    lineFrom: (day) => `с ${day}`,
    yesterdayTitle: (day) => `Вчера, ${day}`,
    yesterdaySub: 'сутки по Киеву; просмотры, лайки и подписчики — то, что добавилось за эти сутки',
    periodTitle: 'По направлениям',
    periodSub: (from) => `с ${from}, в сравнении с таким же отрезком перед ним`,
    unbound: 'Без направления',
    posts: 'посты',
    views: 'просмотры',
    likes: 'лайки',
    comments: 'комментарии',
    shares: 'репосты',
    followers: 'подписчики',
    gained: 'добавилось',
    accountStatsTitle: 'Статистика аккаунта',
    profileViews: 'Просмотры профиля',
    hintFollowers: 'сколько подписчиков было на конец каждого дня',
    hintViews: 'просмотры всех постов, видимых в профиле, вместе — на конец дня',
    hintLikes: 'все лайки аккаунта (число в профиле) на конец дня',
    hintPosts: 'сколько постов вышло за каждый день',
    hintProfileViews: 'сколько раз открывали профиль — на конец дня',
    totalNow: (v) => `всего сейчас ${v}`,
    inPeriod: (v: string) => `${v} за период`,
    postsInPeriodShort: 'вышло за период',
    kpiTitle: 'Главное за период',
    clicks: 'Переходы по ссылкам',
    clicksNotYet: 'ещё не собираются',
    accTableTitle: (n: number) => `Аккаунты · ${n}`,
    accTableSub: 'все аккаунты в одной таблице — клик по заголовку сортирует; название открывает аккаунт',
    colAccount: 'Аккаунт',
    colFollowersLine: 'Подписчики по дням',
    colFollowers: 'Подписчики',
    colFollowersGained: 'За период',
    colViews: 'Просмотры',
    colViewsGained: 'За период',
    colPosts: 'Посты',
    colRead: 'Прочитано',
    numbersNotYet: 'просмотры, лайки и подписчики ещё не прочитаны с телефонов',
    firstReadInPeriod: 'первое чтение',
    notRecommended: 'не в рекомендациях «Для вас»',
    notRecommendedLong: 'TikTok не показывает этот пост в рекомендациях («Для вас») — органического охвата нет',
    foundPost: 'Пост из профиля (не через Ферму)',
    trendsTitle: 'Статистика по дням',
    trendsSub: (n: number) => `как рос каждый направление за ${n} дн. — где он был каждый вечер; пропуск — день ещё не прочитан`,
    viewsAll: 'Просмотры постов',
    likesAll: 'Лайки аккаунтов',
    statsTitle: 'Статистика направления',
    fromProfile: 'из профиля',
    notRead: 'ещё не прочитано',
    best: 'Лучший пост',
    noBest: 'ни один пост ещё не вырос',
    trouble: 'Проблемные аккаунты',
    noTrouble: 'все аккаунты в порядке',
    phonesAccounts: (p, on, a) => `${p} телефонов (${on} на связи) · ${a} аккаунтов`,
    followersTotal: (n) => `${n} подписчиков всего`,
    vsBefore: (sign, pct) => `${sign}${pct} к предыдущему`,
    sameAsBefore: 'как и раньше',
    newSinceBefore: 'раньше не было',
    perDay: 'прирост просмотров за день',
    postsPerDay: 'постов за день',
    noReadings: 'Ни один профиль ещё не прочитан, поэтому просмотры и подписчики неизвестны. Они появятся после первого чтения («Аккаунты» → «Прочитать профиль сейчас» или расписание).',
    phonesTitle: 'Телефоны и аккаунты',
    phonesSub: 'посты, просмотры и подписчики за 7 дней',
    col: { phone: 'Телефон', direction: 'Направление', state: 'Сейчас', accounts: 'Аккаунты', followers: 'Подписчики', posts7: 'Посты 7 д', views7: 'Просмотры 7 д', lastPost: 'Последний пост', alerts: 'Тревоги' },
    noAccounts: 'без аккаунта',
    never: 'никогда',
    phoneAlert: {
      not_recommended: 'есть посты вне рекомендаций',
      offline: 'не на связи', trouble: 'adb', battery_low: 'разряжен', battery_weak_power: 'не заряжается', hot: 'горячий',
      unbound: 'без направления', no_account: 'без аккаунта', account_banned: 'бан', account_limited: 'ограничен',
      account_signed_out: 'вышел из TikTok', account_other_account: 'другой аккаунт', account_no_tiktok: 'нет TikTok',
      account_failed: 'чтение не удалось', account_locked: 'PIN-блокировка',
    },
    feedExplain: 'Каждый пост за выбранный период, больше всего просмотров — сверху. Цифры — с последнего раза, когда телефон открывал пост; «Как рос» показывает, как они менялись между чтениями.',
    feedUnread: (n: number, all: number) => `${n} из ${all} постов телефоны ещё не открывали — цифр по ним пока нет. Они появятся после следующих чтений профиля.`,
    postNotRead: 'Цифр ещё нет — телефон этот пост ещё не открывал.',
    accountUnknown: 'аккаунт неизвестен',
    carries: (links: string) => `ссылка: ${links}`,
    hintPostViews: 'сколько просмотров было у поста на момент каждого чтения',
    hintPostLikes: 'сколько лайков — на момент каждого чтения',
    everyReading: (n: number) => `все чтения (${n})`,
    feedTitle: 'Посты по результату',
    feedSub: (shown, all) => all > shown ? `${shown} из ${all} за период` : `${all} за период`,
    feedNone: 'За этот период постов нет.',
    gainedInPeriod: (n) => `+${n} просмотров за период`,
    found: 'найден в профиле',
    openPost: 'Открыть в TikTok',
    growth: 'Как рос',
    growthNone: 'Пока прочитан только раз — линия появится после следующего чтения.',
    noPicture: 'без картинки',
    battery: (n) => `${n}%`,
  },

  profile: {
    title: 'Чтение профилей',
    sub: 'телефоны открывают свой профиль TikTok и читают, что собрали посты — только чтение, с самым низким приоритетом',
    rules: 'Только чтение: вкладка профиля, посты, «Назад» и «Домой» — без лайков и без набора текста. Телефон, который кто-то держит, пропускается; любой, кто берёт телефон (постинг, человек, Claude), сразу останавливает чтение. Один телефон за раз; каждый аккаунт раз в 6 часов и через час после каждого нового поста; только телефоны с направлением. Блокировку PIN-кодом не трогаем.',
    autoOn: 'Расписание включено',
    autoOff: 'Расписание выключено — чтение только вручную',
    switchOn: 'Включить расписание',
    switchOff: 'Выключить расписание',
    readingNow: (who: string) => `сейчас читается: ${who}`,
    readNow: 'Прочитать профиль сейчас',
    started: 'Читаю — минута-две. Результат появится здесь.',
    never: 'ещё не читали',
    when: (at: string) => `прочитано ${at}`,
    counts: (followers: string, likes: string, posts: number, views: string) => `${followers} подписчиков · ${likes} лайков · прочитано постов: ${posts}, просмотров ${views}`,
    outcome: {
      partial: 'оборвалось на середине — повтор в течение часа',
      ok: 'прочитано', locked: 'телефон заблокирован PIN-кодом', busy: 'телефон был занят — пропущено',
      evicted: 'остановлено: телефон кто-то взял', no_tiktok: 'TikTok не открылся', signed_out: 'в TikTok никто не вошёл',
      banned: 'TikTok показывает бан', other_account: 'на телефоне другой аккаунт', failed: 'чтение не удалось',
    } as Record<string, string>,
    doubtful: (n: number) => `${n} пост. не сопоставлено наверняка — решает человек`,
    notFound: (n: number) => `${n} пост. Фермы нет в профиле`,
    details: 'Что прочитано',
    match: { sure: 'своя публикация', doubtful: 'под вопросом', found: 'найдено в профиле' } as Record<string, string>,
    statNames: { views: 'просмотры', likes: 'лайки', comments: 'комментарии', shares: 'репосты', saves: 'сохранения' } as Record<string, string>,
    statsAt: (at: string) => `по состоянию на ${at}`,
    aiLabel: 'TikTok помечает как сгенерированное ИИ',
    phoneReading: 'читает статистику — можно брать',
  },

  links: {
    title: 'Ссылки',
    sub: 'куда посты ведут людей — сайт, ТГ-канал, что угодно — и какие посты, телефоны и аккаунты их несли',
    rules: 'Ссылка в посте — ровно та, что здесь, без наших коротких ссылок и редиректов: один домен на всех аккаунтах связывает их. Поэтому клики видит только владелец ссылки (аналитика сайта); здесь — все посты, которые её несли. Какая ссылка в посте, Ферма читает из текста на видео и подписи.',
    listTitle: 'Список',
    listSub: (n: number) => `ссылок: ${n}`,
    empty: 'Пока пусто. Админ добавляет ссылки выше — или из уже найденных в постах, ниже.',
    urlPlaceholder: 'адрес, как в посте: manyplay.fun, https://t.me/…',
    namePlaceholder: 'название (необязательно)',
    direction: 'Направление',
    anyDirection: 'любое направление',
    add: 'Добавить',
    carried: (pubs: number, phones: number, accounts: number) => `${pubs} пост. · телефонов: ${phones} · аккаунтов: ${accounts}`,
    notPosted: 'ещё ни в одном посте',
    span: (from: string, to: string) => from === to ? from : `${from} – ${to}`,
    sharedWidely: (phones: number, at: number) => `стоит на ${phones} телефонах (порог ${at}) — один адрес на многих аккаунтах может их связать`,
    otherDirection: 'его несли посты другого направления',
    retire: 'Больше не продвигаем',
    unretire: 'Вернуть',
    retiredList: (n: number) => `не продвигаются: ${n}`,
    unlistedTitle: 'Найдено в постах, но не в списке',
    unlistedSub: 'адреса из текста на видео или подписи — добавьте те, что являются целями',
    foundIn: (n: number, last: string) => `в ${n} пост., последний ${last}`,
    addFound: 'Добавить в список',
  },

  machines: {
    usb: {
      level: (pct) => `${pct}%`,
      charging: 'заряжается',
      weakShort: 'разряжается',
      weakCharge: 'на кабеле, но разряжается — порт хаба не успевает',
      ranFlat: (pct, at) => `разрядился (последний заряд ${pct}%, ${at}) — включи кнопкой`,
      seat: (hub, place) => `хаб ${hub} · место ${place}`,
      hubOnly: (hub) => `хаб ${hub}`,
      group: (hub, n) => `Хаб на порту ${hub} компьютера · телефонов: ${n}`,
      unknownPort: 'порт USB пока неизвестен',
      port: (path) => `USB ${path}`,
      portTitle: (route) => `где висит: ${route}`,
      route: (bus, ports) => `шина ${bus} · порт компьютера ${ports[0]}${ports.slice(1).map((p) => ` → порт хаба ${p}`).join('')}`,
      since: (time) => `отпал в ${time}`,
      gone: 'не виден на USB — отключён или хаб без питания',
      waiting: 'на кабеле — машина переподключит сама',
      trying: (n, max) => `машина переподключает (попытка ${n} из ${max})`,
      gaveUp: (max) => `машина пробовала ${max} раза — нужен человек`,
      stateHint: (state) => state === 'unauthorized'
        ? 'на кабеле, ждёт «Разрешить отладку по USB» на экране'
        : `на кабеле, adb: ${state}`,
      dropped: 'Отпали',
      drops: (n) => `${n}× за 7 дней`,
      dropLine: (at, how) => `${at} — ${how}`,
      backByHub: 'вернула машина',
      backUnplugged: 'кабель вынимали, подключили снова',
      backSelf: 'вернулся сам',
      stillOut: 'всё ещё отпавший',
    },
    title: 'Машины',
    rule: 'Один телефон = один аккаунт TikTok. Укажите аккаунт на каждом телефоне здесь; второй телефон с тем же сервис отклонит.',
    readError: (msg) => `не удалось прочитать список машин: ${msg}`,
    none: 'машин пока нет',
    point: (point) => `площадка ${point}`,
    agent: (v) => `агент ${v}`,
    onWire: 'на связи',
    offline: 'офлайн',
    phones: (n) => `${n} телефон(ов)`,
    onlinePhones: (n) => `онлайн ${n}`,
    unlabelled: (n) => `${n} без метки аккаунта`,
    showPhones: 'телефоны',
    hide: 'скрыть',
    noPhones: 'на этой машине нет телефонов',
    deleteMachine: 'Удалить машину',
    deletePhone: 'Удалить',
    liveCannotDelete: 'Удалить можно только офлайн-телефон — живой перерегистрируется со следующим heartbeat',
    onlineCannotDelete: 'Сначала остановите агент — подключённая машина регистрирует себя снова',
    deleted: (name) => `${name} удалено из нашей базы`,
  },

  confirm: {
    titleMachine: (name) => `Удалить машину ${name}?`,
    titlePhone: (name) => `Удалить телефон ${name}?`,
    ourDbOnly: 'Это убирает запись только из базы Ferma Hub. На машине и телефоне ничего не меняется.',
    cascade: (n) => `Вместе с ней удалятся её ${n} телефон(ов) и их сессии.`,
    phoneNote: 'Телефон исчезнет из списков в нашей базе. Если его снова подключить к машине — зарегистрируется заново.',
    typeName: (name) => `Введите ${name} для подтверждения`,
    math: (a, b, op) => `И решите: ${a} ${op} ${b} = ?`,
    answer: 'Ответ',
    nameMismatch: 'название не совпадает',
    mathWrong: 'неверный ответ',
    cancel: 'Отмена',
    doDelete: 'Удалить',
  },

  common: {
    dash: '—', save: 'Сохранить', dismiss: 'Убрать',
    adminOnly: 'Это может сделать только администратор',
    notYours: 'Изменить или удалить это может только владелец или администратор',
  },

  users: {
    directions: 'Направления',
    allDirections: 'все (админ)',
    noDirections: 'нет — ничего не постит',
    directionsSaved: (email: string) => `Направления ${email} сохранены`,
    title: 'Пользователи',
    sub: 'Кто может войти и что ему разрешено. Google-аккаунты появляются здесь после первого входа; парольные аккаунты создаются ниже.',
    adminOnly: 'Управлять пользователями может только администратор.',
    readError: (msg: string) => `не удалось прочитать пользователей: ${msg}`,
    none: 'пользователей пока нет',
    email: 'E-mail',
    name: 'Имя',
    role: 'Роль',
    createdAt: 'Создан',
    signIn: 'Вход',
    password: 'пароль',
    googleOnly: 'только Google',
    you: 'вы',
    roles: { admin: 'администратор', tester: 'тестировщик' } as Record<string, string>,
    roleHint: 'Администратор управляет телефонами, сценариями, пользователями и чужим контентом; тестировщик работает со своим.',
    resetPassword: 'Задать пароль',
    newPassword: 'Новый пароль',
    minPassword: 'не меньше 8 символов',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    deleteTitle: (email: string) => `Удалить ${email}?`,
    deleteBody: 'Человек больше не сможет войти; его сессии завершатся сразу. Созданные им видео, посты и рассылки останутся.',
    addTitle: 'Добавить парольный аккаунт',
    addSub: 'Для того, у кого нет корпоративного Google-аккаунта. Только корпоративная почта.',
    add: 'Создать',
    created: (email: string) => `${email} создан`,
    roleSaved: (email: string, role: string) => `${email} теперь ${role}`,
    passwordSet: (email: string) => `пароль для ${email} задан`,
    deleted: (email: string) => `${email} удалён`,
  },

  oauth: {
    title: 'Подключить Claude к Ferma Hub',
    asks: (name: string) => `${name} просит работать в Ferma Hub от вашего имени.`,
    goesTo: 'Ответ вернётся на',
    loopback: 'программу на этом компьютере (Claude Code)',
    can: 'Сможет: видеть машины и телефоны, брать телефон на ваше имя и управлять им, загружать видео и исходники, создавать и запускать посты и рассылки.',
    cannot: 'Не сможет: управлять сценариями, телефонами, машинами, пользователями и чужим контентом.',
    revokeLater: 'Отключить его можно в любой момент на странице «Мой Claude».',
    allow: 'Разрешить',
    deny: 'Отклонить',
    working: 'Подключаем…',
    gone: 'Этот запрос истёк или на него уже ответили. Вернитесь в Claude и нажмите Connect ещё раз.',
  },
}
